module.exports = __webpack_public_path__ + "static/media/geometric-alt.9446e5d3.png";